import React from 'react';
import { useExperienceFail } from '@atlassian/jira-experience-tracker/src/ui/experience-fail/index.tsx';
import { ExperienceStart } from '@atlassian/jira-experience-tracker/src/ui/experience-start/index.tsx';
import { ExperienceSuccess } from '@atlassian/jira-experience-tracker/src/ui/experience-success/index.tsx';
import { JIRA_SOFTWARE } from '@atlassian/jira-shared-types/src/application.tsx';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller/src/components/app-editions/index.tsx';

const EXPERIENCE_NAME = 'issueAssociatedDesigns';
const ANALYTICS_SOURCE = 'versionDetails';

export const IssueAssociatedDesignsExperienceStart = () => {
	const appEditions = useAppEditions();
	return (
		<ExperienceStart
			experienceId="jiraVersionDetailsIssueAssociatedDesigns"
			experience={EXPERIENCE_NAME}
			analyticsSource={ANALYTICS_SOURCE}
			edition={appEditions.software}
			application={JIRA_SOFTWARE}
		/>
	);
};

export const IssueAssociatedDesignsExperienceSuccess = () => (
	<ExperienceSuccess experience={EXPERIENCE_NAME} />
);

export const useIssueAssociatedDesignsExperienceFail = () =>
	useExperienceFail({
		experience: EXPERIENCE_NAME,
	});
